import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  Box,
  Text,
  useColorModeValue,
  Flex,
} from "@chakra-ui/react";

interface CommunityData {
  _id: string;
  name: string;
  description: string;
  createdBy: string;
  phone: string;
  email: string;
  underReview: boolean;
  originalData: any;
}

interface CommunityDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  commData?: CommunityData;
}

const DetailRow: React.FC<{ label: string; value: string }> = ({
  label,
  value,
}) => (
  <Box py={3} borderBottom="1px solid" borderColor="gray.200" width="100%">
    <Flex>
      <Text flex="1" fontWeight="500" color="gray.600">
        {label}
      </Text>
      <Text flex="1" color="gray.800">
        {value}
      </Text>
    </Flex>
  </Box>
);

const CommunityDetailModal: React.FC<CommunityDetailModalProps> = ({
  isOpen,
  onClose,
  commData,
}) => {
  console.log("commData", commData?.originalData);

  const bgColor = useColorModeValue("white", "gray.800");
  const headerBgColor = useColorModeValue("#FFF5F5", "gray.700");

  if (!commData?.originalData) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent maxW="600px" bg={bgColor} borderRadius="md">
        <ModalHeader
          bg={headerBgColor}
          borderBottom="1px solid"
          borderColor="gray.200"
          py={4}
        >
          <Text fontSize="xl" color="gray.800">
            Community Details
          </Text>
          <ModalCloseButton />
        </ModalHeader>

        <ModalBody py={6}>
          <VStack spacing={0} align="stretch">
            <DetailRow
              label="Community Name"
              value={commData?.originalData?.name}
            />
            <DetailRow
              label="Phone number"
              value={commData?.originalData?.phone}
            />
            <DetailRow label="Email" value={commData?.originalData?.email} />
            <DetailRow
              label="Total events"
              value={commData?.originalData?.totalEvents}
            />
            <DetailRow label="Community created on" value="01/01/25" />
            <Box py={3} borderBottom="1px solid" borderColor="gray.200">
              <Text fontWeight="600" color="gray.600" mb={2}>
                Description
              </Text>
              <Text color="gray.800">
                {commData?.originalData?.description}
              </Text>
            </Box>
            <Box py={3}>
              <Text fontWeight="600" color="gray.600" mb={2}>
                Reason for starting
              </Text>
              <Text color="gray.800">{commData?.originalData?.reason}</Text>
            </Box>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CommunityDetailModal;
